import { Component, Inject, Optional } from '@angular/core';
import { POPOVER_DATA } from '../popover.service';

interface PopoverData {
  title?: string;
  message?: string;
}

@Component({
  selector: 'sgt-popover-template',
  templateUrl: './template.component.html',
})
export class PopoverTemplateComponent {
  constructor(@Optional() @Inject(POPOVER_DATA) public data?: PopoverData) {}
}
